import React from 'react';
import Svg, { Path } from 'react-native-svg';

export interface CircleCheckOutlineIconProps {
    size?: number;
    color?: string;
}

/** Single-stroke checkmark-in-circle, used by NoteBanner's success variant. */
export function CircleCheckOutlineIcon({
    size = 19,
    color = '#1A5E20',
}: Readonly<CircleCheckOutlineIconProps>) {
    return (
        <Svg width={size} height={size} viewBox="0 0 19 19" fill="none">
            <Path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6.833 9.333 8.5 11l3.333-3.333m5.834 1.666A8.333 8.333 0 1 1 1 9.333a8.333 8.333 0 0 1 16.667 0Z"
            />
        </Svg>
    );
}

export default CircleCheckOutlineIcon;
